module.exports = __webpack_public_path__ + "assets/checkmark_outline-a5d3b9.svg";